import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="screen-line-before">
      <div className="mx-auto max-w-3xl px-4 py-6 md:border-x">
        <div className="flex items-center justify-between text-sm text-muted-foreground">
          <span>© {new Date().getFullYear()} Arvind Padala</span>
          <a
            href="https://github.com/ArvindPadala"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors duration-200"
          >
            GitHub ↗
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;